<div class="container-fluid bg-white">

  <div class="page">

    <div class="page-header alternate">
      <h2 class="page-title alternate-heading text-center">
        <span class="text-primary">{{'View here' | translate}}</span><br/>
        <span>{{'all posts' | translate}}</span>
      </h2>
    </div>

    <div class="page-body">

      <div class="container-smaller">

        <div class="content-wrapper">

          <div class="content">

            <div class="grid grid-blog">

              <div class="row">

                <div class="col-6 col-sm-4 grid-item grid-item-blog grid-item-image-bg" *ngFor="let node of view.data">

                  <a class="grid-item-link" [routerLink]="'/posts/' + (node.permalink ? node.permalink : node.id)">

                    <div class="grid-item-image-wrapper" *ngIf="node.imageUri" [ngStyle]="{'background-image' : 'url(' + (node.imageUri ? node.imageUri : '') + ''}">
                      <img class="grid-item-image grid-item-image-blog img-fluid" [src]="node.imageUri" />
                    </div>

                    <h3 class="grid-item-title">
                      {{externalpageService.getTranslatedTitle(node)}}
                    </h3>
                  </a>
                </div>

              </div>

            </div>

            <ngb-pagination (pageChange)="setPage($event)" [(page)]="view.queryParams.pageNumber" [pageSize]="view.queryParams.pageSize" [collectionSize]="view.queryParams.totalItems"></ngb-pagination>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
